import { z } from 'zod';

export const zodSupplierLetterMetaSchema = z.object({
  downloadUrl: z.string().nullable().optional(),
  fileId: z.uuid(),
  fileName: z.string(),
  mimeType: z.string(),
  uploadedAt: z.iso.datetime({ offset: true }).nullable(),
});
